import apiClient from '@/services/APIv2'

export default {
  getSwaps (params) {
    return apiClient().get('/swaps', { params })
  },
  getSwap (toAdId) {
    return apiClient().get('/swaps/' + toAdId)
  },
  getMatches () {
    return apiClient().get('/matches')
  }
}
